import React, { useState } from 'react';
import { Box, Typography, Dialog, IconButton, Grid, CardActionArea } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useDispatch, useSelector } from 'react-redux';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { depositSelector } from '../../../store/common/common.selector';
import { setOpenDepositDialog } from '../../../store/common/common.reducer';
import { userDeposit } from '../../../apis/payment';
import commafy from '../../../utils/commafyHelper';
import CustomButton from '../../UI/CustomButton';
import CustomInput from '../../UI/CustomInput';
import './deposit.scss';

const useStyles = makeStyles(() => ({
  paper: {
    direction: 'rtl',
    borderRadius: '1rem',
  },
}));

enum AmountValue {
  Value1 = 200000,
  Value2 = 400000,
  Value3 = 600000,
  Value4 = 800000,
}

const DepositDialog = () => {
  const styles = useStyles();
  const dispatch = useDispatch();
  const [amount, setAmount] = useState(AmountValue.Value1);
  const [loading, setLoading] = useState(false);

  const openDepositDialog = useSelector(depositSelector);

  const handleClose = () => dispatch(setOpenDepositDialog(false));

  const onClickDepositButton = () => {
    setLoading(true);
    userDeposit(amount * 10)
      .then((res: any) => {
        handleClose();
        window.open(res?.payment_url, '_self');
      })
      .finally(() => setLoading(false));
  };

  function DepositBox(deposit: number) {
    return (
      <CardActionArea className='cardActionArea' onClick={() => setAmount(deposit)}>
        <Box
          className='depositBox'
          bgcolor={deposit === amount ? 'background.footer' : 'transparent'}
          sx={{ border: `1px solid ${deposit === amount ? '#005B96' : '#6A6E73'}` }}
        >
          <Typography color='text.dark'>
            {commafy(deposit)}
            <span className='unit'>تومان</span>
          </Typography>
        </Box>
      </CardActionArea>
    );
  }

  return (
    <Dialog
      onClose={handleClose}
      open={openDepositDialog}
      maxWidth='lg'
      classes={{ paper: styles.paper }}
    >
      <Box className='mainDialog'>
        <Box className='header'>
          <Typography color='text.main'>مبلغ افزایش موجودی</Typography>
          <IconButton onClick={handleClose}>
            <CloseRoundedIcon color='action' />
          </IconButton>
        </Box>

        <CustomInput
          label={amount ? 'مبلغ دلخواه (تومان)' : ''}
          placeholder='مبلغ دلخواه (تومان)'
          value={amount}
          maxLength={8}
          error={false}
          inputMode='numeric'
          onChangeHandler={(value) => setAmount(value)}
        />

        <Grid container py={2}>
          <Grid item lg={3} md={3} xs={6} p={0.5}>
            {DepositBox(AmountValue.Value1)}
          </Grid>
          <Grid item lg={3} md={3} xs={6} p={0.5}>
            {DepositBox(AmountValue.Value2)}
          </Grid>
          <Grid item lg={3} md={3} xs={6} p={0.5}>
            {DepositBox(AmountValue.Value3)}
          </Grid>
          <Grid item lg={3} md={3} xs={6} p={0.5}>
            {DepositBox(AmountValue.Value4)}
          </Grid>
        </Grid>

        <Box className='footer'>
          <CustomButton fullWidth variant='outlined' onClick={handleClose}>
            انصراف
          </CustomButton>
          <CustomButton
            fullWidth
            disabled={loading}
            loading={loading}
            onClick={onClickDepositButton}
          >
            شارژ کیف پول
          </CustomButton>
        </Box>
      </Box>
    </Dialog>
  );
};

export default DepositDialog;
